import HolderName from '@/models/creditCard/holderName';

export default (value: string): boolean => HolderName.isValid(value);

